import { Grid, Typography } from '@material-ui/core';

import { TextFieldElement } from 'react-hook-form-mui';
import { validateQuestion } from '../utils/checks';

import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';

import { WorkloadClient } from '@internal/workload-api-helper';
import { CustomTooltip, useStyles } from '../CustomTooltip';
import { CatalogFormInputProps } from '../types';

export function PfgOwner(props: CatalogFormInputProps) {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = new WorkloadClient(configApi, oauthApi);

  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <TextFieldElement
          disabled={props.disabled}
          name="pfg_owner"
          label="Owning group"
          variant="outlined"
          className={classes.root}
          validation={{
            pattern: {
              value: /^\S+@\S+\.\S+$/,
              message: 'Must be an email address',
            },
            validate: async value => {
              return await validateQuestion(
                'pfg_owner',
                value,
                props.apiValidation,
                workloadClient,
              );
            },
          }}
          required
          fullWidth
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              Must be 63 characters or less, and have at least two full time
              employees in it.
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
